<template>
  <div class="title-field container" @keydown.stop>
    <div class="title">
      <span>标题</span>
      <i class="dot"></i>
    </div>
    <div class="input-wrapper">
      <input
        type="text"
        class="input"
        placeholder="好的标题可吸引更多的观众来看"
        v-model="inputValue"
        :maxlength="maxlength"
        @focus="inputFocus"
        @blur="inputBlur"
      />
      <div class="char-count">{{inputValue.length}}/{{maxlength}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // inputValue: "",
      maxlength: 32
    };
  },
  computed: {
    ...mapGetters({
      subtitleObj: "subtitle/subtitleObj"
    }),
    inputValue: {
      get () {
        return (this.subtitleObj || {}).title || '';
      },
      set (val) {
        this.$store.commit('subtitle/setTitle', val);
      }
    }
  },
  methods: {
    inputFocus () {
      this.backupValue = this.inputValue;
    },
    inputBlur () {
      if (!this.inputValue) {
        this.inputValue = this.backupValue;
      }
    }
  },
  props: {
    value: String
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
}
.title {
  position: absolute;
  top: 50%;
  right: calc(100% + 28px);
  transform: translateY(-50%);
  min-width: 100px;
  text-align: right;
  font-size: 14px;
  color: #474261;
}
.input {
  width: 528px;
  height: 40px;
  background: #f8f8fc;
  border: 1px solid #ddd9eb;
  font-size: 14px;
  color: #c1c1d0;
  padding-left: 15px;
  padding-right: 60px;
  color: #333;
  &::placeholder {
    color: #c1c1d0;
  }
}
.dot {
  position: absolute;
  top: -2px;
  left: 102%;
  width: 4px;
  height: 4px;
  background: #ff133a;
  border-radius: 50%;
}
.char-count {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #c2c2d9;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitleExport/titleField.vue